module.exports = __webpack_public_path__ + "AakashParameswaran-f2304551.webp";